import { render, staticRenderFns } from "./MeasurementsCard.vue?vue&type=template&id=3b1ee4d8&scoped=true"
import script from "./MeasurementsCard.vue?vue&type=script&lang=js"
export * from "./MeasurementsCard.vue?vue&type=script&lang=js"
import style0 from "./MeasurementsCard.scss?vue&type=style&index=0&id=3b1ee4d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ee4d8",
  null
  
)

export default component.exports